import { Affix, ActionIcon, Tooltip } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { IconChevronRight } from '@tabler/icons-react';

/** Synchron mit `components/layout/BottomNav.module.css` → `.bottomNav { height: … }` */
const BOTTOM_NAV_HEIGHT_PX = 70;

export interface KianFABProps {
  /** Aktion zum Schließen/Einklappen des offenen Panels (z. B. minimize) */
  onMinimize: () => void;
}

/**
 * Kompakter Einklapp-Knopf, solange das KIAN-Panel offen ist.
 * Der geschlossene Zustand gehört inzwischen dem `ServiceHubFAB` (Speed-Dial).
 */
export function KianFAB({ onMinimize }: KianFABProps) {
  // Wie `BottomNav` in `AppLayout` (`hiddenFrom="sm"`) — unter sm ist die Leiste sichtbar; FAB sitzt sonst oben drauf
  const bottomNavVisible = useMediaQuery('(max-width: 47.99em)');
  // `--fab-lift` setzen Seiten mit einer Eingabeleiste am unteren Rand (Chat-Inbox)
  // auf deren Höhe. Der Knopf weicht dann nach oben aus, statt dem Schreibfeld
  // rechts Platz wegzunehmen — das machte es auf dem Handy unbrauchbar schmal.
  const bottom = bottomNavVisible
    ? `calc(1.5rem + ${BOTTOM_NAV_HEIGHT_PX}px + env(safe-area-inset-bottom, 0px) + var(--fab-lift, 0px))`
    : 'calc(1.5rem + env(safe-area-inset-bottom, 0px) + var(--fab-lift, 0px))';

  return (
    // Über Flyout/Drawer (5200), damit der Einklapp-Button erreichbar bleibt
    <Affix position={{ bottom, right: 'var(--fab-right, 1.5rem)' }} zIndex={5250}>
      <Tooltip label="KIAN einklappen" position="left" withArrow>
        <ActionIcon
          size={40}
          radius="xl"
          variant="default"
          color="gray"
          onClick={onMinimize}
          aria-label="KIAN einklappen"
          data-testid="kian-fab-minimize"
          style={{
            boxShadow: '0 2px 12px rgba(0, 0, 0, 0.35)',
            border: '1px solid var(--mantine-color-dark-4)',
          }}
        >
          <IconChevronRight size={22} stroke={2.25} />
        </ActionIcon>
      </Tooltip>
    </Affix>
  );
}
